<template>
	<AssessmentCharacteristics class="persuasion-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `handshake-simple` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.PersuasionCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";
export default {
	name: "PersuasionCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	computed: {
		characteristics() {
			return this.assessment?.teamingContent?.effectivePersuasionGuidance || [];
		},
	},
};
</script>

<style lang="scss" scoped></style>
